export const API_ROOT = 'http://192.168.0.156:9195' // 连接地址
export const voiceTime = 30// 语音时长（秒）



//////////////////
// WEBPACK FOOTER
// ./static/config.js
// module id = /98u
// module chunks = 0